<form [formGroup]="_form" (ngSubmit)="forgotPasswordConfirm()" class="form-horizontal">

  <!--title-->
  <h2 mat-dialog-title>
    <i class="material-icons m-r-10">lock_open</i>
    <span>{{ 'Modules.Login.ForgotPassword.Title' | translate }}</span>
  </h2>

  <!--content-->
  <mat-dialog-content>
    <div [innerHtml]="'Modules.Login.ForgotPassword.Summary' | translate"></div>
    <mat-form-field floatPlaceholder="auto" class="float-auto">
      <input matInput placeholder="{{ 'Modules.Login.ForgotPassword.Form.Email' | translate }}" type="email" formControlName="email">
      @if ((email.errors?.required || email.errors?.email) && email.touched) {
        <mat-error>
          {{ 'Commons.Validation.Email' | translate}}
        </mat-error>
      }
    </mat-form-field>
  </mat-dialog-content>

  <!--actions-->
  <mat-dialog-actions>
    <button type="submit" mat-flat-button mat-ripple color="accent" [class.disabled]="!_form.valid">
      <i class="material-icons m-r-10">check</i> {{ 'Commons.Actions.Confirm' | translate}}
    </button>
    <button type="button" mat-dialog-close mat-button mat-ripple>
      {{'Commons.Actions.Cancel' | translate}}
    </button>
  </mat-dialog-actions>

</form>